module.exports = __webpack_public_path__ + "img/IRM_SPD_logo.db96f236.svg";